export type Primitive = (typeof primitives)[number]

export const primitives = [
  'boolean',
  'enum',
  'float',
  'floatPercent',
  'integer',
  'json',
  'string',
  'stringCode',
] as const
